import { storage } from '@/lib/storage'
import { PosModel, PosSync } from '@/types'

export const DEVICE_KEY = 'pos.device'
export const PROFILE_KEY = 'pos.profile'
export const CASHIER_KEY = 'pos.cashier'

export interface Cashier {
  _id: string
  name: string
  /** Effective permissions when they signed in: their own plus every role's (ROLE_PERMISSION.md §5). */
  permissions: string[]
  /** The role keyed `admin` passes every check. */
  is_admin: boolean
}

/** The terminal this device was set up as (§15.10), or null before setup. */
export const currentDevice = () => storage.read<PosSync.Device | null>(DEVICE_KEY, null)

/** The staff member who signed in with a password (the sync session, §15.10 Q30). */
export const currentProfile = () => storage.read<PosModel.StaffProfile | null>(PROFILE_KEY, null)

/** The cashier acting now, signed in by PIN or password; every record carries their id (§15.10 item 4). */
export const currentCashier = () => storage.read<Cashier | null>(CASHIER_KEY, null)

export const requireDevice = () => {
  const device = currentDevice()
  if (!device) throw new Error('This device is not set up.')
  return device
}
